export default __webpack_public_path__ + "static/carousel-9-dd176de69389c75b8f87adc2d507376e.jpg";